// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__gUw5y","title":"Info_title__JtGHK","selects":"Info_selects__3Z89M","requiredAsterisk":"Info_requiredAsterisk__1y1fU"};